import Loadable from "react-loadable";

const LazyMyMeetings = Loadable({
  loader: () => import(/* webpackChunkName: 'list-my-meetings' */ "./index"),
  loading: () => 'loading...'
});

export default LazyMyMeetings;
